import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiBusinessUnitViewProfileTabBase } from '@fi-app/business-unit/business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-view-profile-tab-base';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-business-unit-general-tab',
    templateUrl: './fi-business-unit-general-tab.component.html',
    styleUrls: ['./fi-business-unit-general-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-general-tab' },
    standalone: false,
})
export class FiBusinessUnitGeneralTabComponent extends FiBusinessUnitViewProfileTabBase {
    isCheckPresenceEnabledForCustomer(): boolean {
        return this.injector.get(FiCustomerDataService).customerData.ChecklistPresenceEnabled;
    }
}
